<template>
  <div id="app">
    <commonhead :active_menu="-1" />
    <div class="user_center_msg">
      <div class="content_wrap">
        <!--个人中心公用侧边栏-->
        <UserLeftMenu :active_menu_index="8" />
        <div class="right_content">
          <p class="head_title">短信提醒</p>
          <p class="notice_info">开启后，您将在上课前30分钟收到短信提醒</p>
          <div class="info_area">
            <div class="item">
              <span class="key">您的手机号是</span>
              <span class="value">{{mobile}}</span>
            </div>
            <div class="item">
              <span class="key">免费短信有效期至</span>
              <span class="value">无</span>
            </div>
            <div class="item dif">
              <span class="key">开启或关闭短信提醒</span>
              <span class="icon hand_point" v-if="!btn_turn" @click="change_btn(true)">
                <img src="../../assets/image/user_center/btn (1).png" alt class="pic_full" />
              </span>
              <span class="icon hand_point" v-if="btn_turn" @click="change_btn(false)">
                <img src="../../assets/image/user_center/btn (2).png" alt class="pic_full" />
              </span>
            </div>
          </div>
          <p class="tips">Tips:</p>
          <p class="tips_text">1、购买VIP会员后将免费赠送短信提醒，该功能暂不支持普通会员；</p>
          <p class="tips_text">2、用户获得免费的短信提醒后，默认是开启状态。如不需要，点击关闭即可。</p>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="bottom">
      <div class="content pr">
        <span class="gift">
          <img src="../../assets/image/user_center/icon (1).png" alt class="pic_full" />
        </span>
        <span class="free_info">
          每成功推荐一个朋友学习，满足奖励条件后即可获得
          <span class="red">200元充值</span>，奖励可累积哦！
        </span>
        <div class="qr_code">
          <div class="qrcode_img">
            <canvas id="QRCode"></canvas>
          </div>
          <p class="notice_info">
            <span class="wechat_icon">
              <img src="../../assets/image/user_center/icon (2).png" alt class="pic_full" />
            </span>
            <span>扫码分享到微信</span>
          </p>
        </div>
        <button class="call_btn hand_point">查看奖励</button>
      </div>
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import UserLeftMenu from "../common/user_left_menu.vue";
import QRCode from "qrcode"; //引入生成二维码插件
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    UserLeftMenu
  },
  data: function() {
    return {
      btn_turn: false, //是否开启短信提醒
      mobile: ""
    };
  },
  mounted: function() {
    this.get_info();
    this.get_share_code();
  },
  methods: {
    change_btn(type) {
      let self = this;
      common.requestFun(
        self,
        "post",
        "/student/course/notify",
        {
          use: type ? 1 : 0
        },
        res => {
          if (res.data.code == 200) {
            self.$message({
              showClose: true,
              message: "设置成功",
              type: "success"
            });
            self.btn_turn = type;
          } else {
                if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    },
    get_info() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, res => {
        if (res.data.code == 200) {
          self.mobile = res.data.data.mobile;
          self.btn_turn = res.data.data.use_notify == 1 ? true : false;
        }
      });
    },
    get_share_code() {
      //生成分享二维码
      let self = this;
      common.requestFun(self, "get", "/student/recommend_code", {}, res => {
        if (res.data.code == 200) {
          var msg = document.getElementById("QRCode");
          QRCode.toCanvas(
            msg,
            `http://gemsbaby.com/share/index.html?origin_code=${res.data.data}`,
            function(error) {
              console.log(error);
            }
          );
        }
      });
    }
  }
};
</script>
<style scoped src="./user_center_msg.css"></style>
